import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from './badge.style';

const BadgeComponent = ({ label = 'badge', type = 'default', width, outline = false }) => {
    return <Badge type={type} $outline={outline} $width={width} className='box-shadow'>{label}</Badge>;
};

BadgeComponent.propTypes = {
    label: PropTypes.string,
    type: PropTypes.oneOf(['default', 'success', 'warning', 'error']),
    outline: PropTypes.bool,
    width: PropTypes.number,
};

export default BadgeComponent;
